import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { GlobalCopilotDrawerProps } from './GlobalCopilotDrawer';

export const loadGlobalCopilotDrawer = (): Promise<typeof import('./GlobalCopilotDrawer')> =>
  import(/* webpackChunkName: "4-feat-global-copilot-drawer" */ './GlobalCopilotDrawer');

const GlobalCopilotDrawerLoader = async () => {
  const { GlobalCopilotDrawer } = await loadGlobalCopilotDrawer();

  return { default: GlobalCopilotDrawer };
};

export const LoadableGlobalCopilotDrawer: ComponentType<GlobalCopilotDrawerProps> =
  lazyLoadOnRender<GlobalCopilotDrawerProps>({
    loader: GlobalCopilotDrawerLoader,
  });
